import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { TablerIconsModule } from "angular-tabler-icons";
import * as TablerIcons from 'angular-tabler-icons/icons';
import { CluBeSnackbarService } from "src/app/@clu-be/apps/@services/clube-snackbar.service";
import { MaterialModule } from "src/app/material.module";
import { CluNumpadDialogModule } from "src/app/utils/clu-numpad-dialog/clu-numpad-dialog.module";
import { ReleaseNotesBEComponent } from "./release-notes-be/release-notes-be.component";
import { ReleaseNotesComponent } from "./release-notes.component";
import { ReleaseNotesFEComponent } from "./release-notes-fe/release-notes-fe.component";

@NgModule({
    declarations: [
        ReleaseNotesComponent,
        ReleaseNotesFEComponent,
        ReleaseNotesBEComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        CluNumpadDialogModule,
        TablerIconsModule.pick(TablerIcons),
    ],
    providers: [
        CluBeSnackbarService
    ]
})
export class ReleaseNotesModule {}